import { combineReducers } from 'redux';
import fundDeclaration from "./fundDeclaration";

export const fundDeclarations = combineReducers({
    fundDeclaration
});
